import { RouterProvider } from "react-router-dom";

import router from "./router/Router";
import adminRouter from "./router/AdminRouter";
import { useAuth } from "auth/AuthContext";

function App() {
    const { isAdmin } = useAuth();

    return <RouterProvider router={isAdmin ? adminRouter : router} />;
}

export default App;
